import React from "react"
import dayjs from "dayjs"
import Map from "../map"
import UserAvatar from "../photographers/photograher_avatar"
import {formatDatetime} from "../../util/date_util"
import {railsToJsTimezoneMap} from "../../util/timezone_utils"
import PhotographerTeamNotes from './photographer_team_notes'
import ShootConfirmationControls from '../shoot_confirmation_controls'
import '../../../stylesheets/photographer_project.scss'

class EditProjectContractorDetails extends React.Component {
  constructor(props) { super(props); this.state = {mapExpanded:false}; }
  render() {
    const {project, currentUser, onCancel} = this.props
    if (!project) return <div role="status">Loading photoshoot details…</div>
    const packages = Object.values(project?.packages || {}).filter(pack => pack.contractor?.id === currentUser.id)
    const address = project.address || {}
    const addressText = [address.apartment_number, address.formatted_address || [address.street1, address.city, address.region, address.zip_code].filter(Boolean).join(', ')].filter(Boolean).join(' ')
    const directions = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(addressText)}`
    const timezone = railsToJsTimezoneMap[address.timezone] || 'America/New_York'
    const today = dayjs().tz(timezone).format('YYYY-MM-DD')
    const showPhone = packages.some(pack => dayjs(pack.appointment_time).tz(timezone).format('YYYY-MM-DD') === today)
    const appointments = Object.values(packages.reduce((groups, pack) => {
      const key = pack.appointment_time
      if (!groups[key]) groups[key] = {time:key, services:[]}
      if (!groups[key].services.includes(pack.service_title)) groups[key].services.push(pack.service_title)
      return groups
    }, {})).sort((a,b) => new Date(a.time) - new Date(b.time))
    const rates = Object.fromEntries((currentUser.contractor_sub_services || []).map(rate => [rate.sub_service_id, rate.payout]))
    const rows = packages.flatMap(pack => (pack.sub_services || []).map(sub => ({key:`${pack.id}-${sub.id}`, service:pack.service_title, title:sub.title, payout:Number(rates[sub.id] ?? sub.contractor_payout ?? 0)})))
    const bonus = packages.reduce((sum, pack) => sum + Number(pack.bonus_payout || 0), 0)
    const total = rows.reduce((sum, row) => sum + row.payout, bonus)
    return <div className="photographerProjectDetails projectDetailsSmallUpdates">
      <section className="projectPhotoshootBubble" aria-labelledby="photographer-shoot-details">
        <h2 id="photographer-shoot-details" className="editProjectEditTitle">Photoshoot Details</h2>
        <div className="photographerClientRow">
          <div className="projectAppointmentPerson">
            <div className="projectPersonAvatar"><UserAvatar user={project.client}/></div>
            <div className="projectPersonText"><div className="projectCustomerName">{project.client?.first_name} {project.client?.last_name}</div><div className="projectCustomerType">Client</div></div>
          </div>
          <div className="photographerProjectActions">
            <a className="projectDetailAction" href={directions} target="_blank" rel="noopener noreferrer">Get Directions</a>
            {showPhone && project.client?.phone_number && <a className="projectDetailAction" href={`tel:${project.client.phone_number.replace(/[^+0-9]/g,'')}`}>Call Client</a>}
          </div>
        </div>
        <div className="photographerProperty"><span className="projectAppointmentLabel">Property address</span><a href={directions} target="_blank" rel="noopener noreferrer">{addressText}</a></div>
        <div className="photographerAppointmentList">{appointments.map(appointment => <div className="photographerAppointment" key={appointment.time}>
          <strong>{formatDatetime(appointment.time, 'MM/DD/YYYY, hh:mm A z', address.timezone || project.client?.timezone)}</strong>
          <span>{appointment.services.join(' · ')}</span>
          {(project.shoot_assignments || []).filter(item => new Date(item.appointment_time).getTime() === new Date(appointment.time).getTime()).map(item => <ShootConfirmationControls key={item.assignment_key} assignment={item} compactAnswered/>)}
        </div>)}</div>
        {project.notes && <section className="photographerClientInstructions"><h3>Client instructions</h3><p>{project.notes}</p></section>}
      </section>
      <details className="projectDetailMap" onToggle={event => this.setState({mapExpanded:event.currentTarget.open})}>
        <summary>View Map</summary>{this.state.mapExpanded && <div className="editProjectMap"><Map projects={[project]}/></div>}
      </details>
      <section className="photographerAssignedServices" aria-labelledby="photographer-assigned-services">
        <h2 id="photographer-assigned-services">Your services &amp; payout</h2>
        <div className="photographerPayoutTable"><table><thead><tr><th>Service</th><th>Option</th><th>Payout</th></tr></thead>
          <tbody>{rows.map(row => <tr key={row.key}><td>{row.service}</td><td>{row.title}</td><td>${row.payout.toFixed(2)}</td></tr>)}
            {bonus > 0 && <tr><td colSpan="2">Additional payout</td><td>${bonus.toFixed(2)}</td></tr>}
          </tbody><tfoot><tr><th colSpan="2">Total</th><td>${total.toFixed(2)}</td></tr></tfoot>
        </table></div>
      </section>
      <PhotographerTeamNotes key={project.id} project={project}/>
    </div>
  }
}
export default EditProjectContractorDetails
